import { Box, Checkbox, ListItem, ListItemText } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import React from 'react';
import { ReactComponent as DeviceIcon } from '../../../../assets/enhed_01.svg';
import { ReactComponent as SelectedDeviceIcon } from '../../../../assets/selectedDevice.svg';
import { localized } from '../../../../state/i18n/i18n';
import './device-menu-item.scss';

class DeviceMenuItem extends React.PureComponent {
    constructor(props) {
    super(props);
    this.checkBoxColor = {color: props.checkBoxColor};
    this.state = {calibrationFactor: this.props.calibrationFactor};
  }

  onIconClicked = () => {
    this.props.onMenuItemClicked(this.props.identifier);
  };

  setFactor = (e) => {
    let newCalibrationFactor = this.props.calibrationFactor;
    newCalibrationFactor = parseFloat(e.target.value);
    this.setState({calibrationFactor: newCalibrationFactor});
  };

  saveFactorChanges = async () => {
    if (this.state.calibrationFactor && this.props.name && this.props.saveFactorUpdate) {
      // save here
    }
  };

  render() {
    const {selected, name, active, identifier, checkBoxColor} = this.props;
    // const {calibrationFactor} = this.state;
    return (
      <div>
        <div onClick={this.onIconClicked} className="mobile alignItemsCenter deviceDrawerItemContainer lato">
          {selected ? (
            <SelectedDeviceIcon fill={checkBoxColor} className="deviceIconChecked" />
          ) : (
            <DeviceIcon fill={checkBoxColor} className="deviceIcon" />
          )}

          <ListItemText className="deviceName" primary={name} />
        </div>

        <ListItem className="desktop deviceDrawerItemContainer" alignItems="flex-start" key={identifier}>
          <Box display="flex">
            <Box className="nameAndDot">
              <Tooltip title={name} TransitionComponent={Zoom}>
                <ListItemText className="deviceName lato" primary={name} />
              </Tooltip>
              <div className="deviceDrawerItem">
                <FiberManualRecordIcon className={'activeDot ' + (active ? 'active' : 'inActive')} />
                <ListItemText
                  className="lato deviceMenuName multiline"
                  primary={active ? localized('Active') : localized('InActive')}
                />
              </div>
            </Box>
            {/* <Box className="determineWidth">
              <label className="label"> {localized('CalibrationFactor')} </label>
              <input
                step={0.001}
                className="calibration"
                type="number"
                value={calibrationFactor || ''}
                onChange={this.setFactor}
                onBlur={this.saveFactorChanges}
              />
            </Box> */}

            <Box className="checkBoxDevices">
              <Checkbox
                onClick={this.onMenuItemClicked}
                style={this.checkBoxColor}
                className="heightOfDeviceCheckbox"
                checked={selected ? true : false}></Checkbox>
            </Box>
          </Box>
        </ListItem>
      </div>
    );
  }

  onMenuItemClicked = () => {
    this.props.onMenuItemClicked(this.props.identifier);
  };
}

export default DeviceMenuItem;
